import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Table, Spin, Button, Modal, Tooltip } from "antd";
import { EditOutlined, DeleteOutlined, AuditOutlined } from "@ant-design/icons"; // Icons from Ant Design
import StockTable from "../StockTable/StockTable";

// import ShippingCreationForm from "../../Forms/ShippingCreationForm/ShippingCreationForm"
const ShippingDashboardTable = ({
  history,
  loading,
  data,
  callReFetch,
  dispatch,
}) => {
  const [selectedShipping, setSelectedShipping] = useState(null);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isDetailModalVisible, setIsDetailModalVisible] = useState(false);

  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  // Update isMobileView based on window shipping
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleOpenEditModal = async (id) => {
    const shippingToEdit = dataList.find((shipping) => shipping._id === id);
    if (shippingToEdit) {
      setSelectedShipping(shippingToEdit);
      setIsEditModalVisible(true);
    }
  };

  const handleTableOnChange = (pagination, filteredInfo, sorter) => {
    if (pagination?.current != null)
      dispatch({ type: "current", payload: pagination.current });
    if (pagination?.pageSize != null)
      dispatch({ type: "pageSize", payload: pagination.pageSize });
    dispatch({ type: "sorter", payload: sorter });
    dispatch({ type: "filteredInfo", payload: filteredInfo });
    callReFetch();
  };

  const statusFilter = [
    { text: "In Stock", value: "in stock" },
    { text: "In Delivery", value: "in delivery" },
  ];

  const dataList = Array.isArray(data?.data) ? data.data : [];

  const renderFilter = (items) => {
    const filterField = {
      status: statusFilter,
      sender: dataList.length
        ? [...new Set(dataList.map((item) => item.sender))]
            .filter(Boolean)
            .map((code) => ({ text: code, value: code }))
        : [],
      destination: dataList.length
        ? [...new Set(dataList.map((item) => item.destination))]
            .filter(Boolean)
            .map((code) => ({ text: code, value: code }))
        : [],
    };
    return filterField[items];
  };

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return `${d.getFullYear()}-${(d.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${d.getDate().toString().padStart(2, "0")}`;
  };

  const columns = [
    {
      title: "Tgl Retur",
      dataIndex: "tanggal_kirim",
      key: "tanggal_kirim",
      sorter: true,
      render: formatDate,
    },
    {
      title: "No. Nota retur",
      dataIndex: "noForm",
      key: "noForm",
      sorter: true,
      filterSearch: true,
      onFilter: (value, record) =>
        record.noForm && record.noForm.includes(value),
    },
    {
      title: "No. Nota penjualan",
      dataIndex: "noSJ",
      key: "noSJ",
      sorter: true,
      filterSearch: true,
      onFilter: (value, record) =>
        record.noSJ && record.noSJ.includes(value),
    },
    {
      title: "Kode outlet",
      dataIndex: "sender",
      key: "sender",
      sorter: true,
      filters: renderFilter("sender"),
    },
    {
      title: "Destination",
      dataIndex: "destination",
      key: "destination",
      sorter: true,
      filters: renderFilter("destination"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: true,
      filters: statusFilter,
    },
    {
      title: "Total Qty",
      dataIndex: "totalQuantity",
      key: "totalQuantity",
      sorter: true,
    },
    {
      title: "Total Cost",
      dataIndex: "totalCost",
      key: "totalCost",
      sorter: true,
      render: (val) => (val != null ? Number(val).toLocaleString() : "-"),
    },
    {
      title: "Tanggal Terima ETA",
      dataIndex: "tanggal_terima_eta",
      key: "tanggal_terima_eta",
      sorter: true,
      render: formatDate,
    },
    {
      title: "Alasan retur",
      dataIndex: "keterangan",
      key: "keterangan",
    },
  ];

  // Ensure data is an array before passing to Table
  // const tableData = Array.isArray(data) ? data : [];
  const paginationConfig = data?.pagination
    ? {
        total: data.pagination.total,
        current: data.pagination.current,
        pageSize: data.pagination.pageSize,
        showSizeChanger: true,
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} of ${total} items`,
      }
    : false;

  return (
    <>
      <div style={{ width: "80vw" }}>
        <Spin tip="Loading shipping data..." spinning={loading}>
          <Table
            columns={columns}
            dataSource={dataList}
            pagination={paginationConfig}
            onChange={(pagination, filteredInfo, sorter) =>
              handleTableOnChange(pagination, filteredInfo, sorter)
            }
          />
        </Spin>
      </div>
    </>
  );
};

ShippingDashboardTable.propTypes = {};

export default ShippingDashboardTable;
